
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Loading from './Loading';
import { Button, OverlayTrigger, Tooltip, Glyphicon } from 'react-bootstrap';

class _Button extends PureComponent {
    render() {
        let {label, disabled, showTooltip, className, loading, loadingLabel, bsStyle, onClick, img, imgStyle, icon, iconStyle, tooltip, tooltipPosition, hideOnMobile, ...props} = this.props;
        if (hideOnMobile && __IS_MOBILE__) {
            return (<span/>);
        }

        let loadingClassName = undefined;
        if (loading) {
            loadingClassName = "LoadingButton__icon";
            if (!loadingLabel) {
                label = `${label} ...`;

            } else {
                label = loadingLabel;
            }

            loading = (<Loading inline delay={false}/>);
        }

        if (img) {
            img = (<img src={img} className={loadingClassName} style={imgStyle}/>);
        }

        if (icon) {
            icon = (<Glyphicon glyph={icon} className={loadingClassName} style={iconStyle}/>);
        }

        let button = (
          <Button {...props}
                  className={className}
                  data-hj-whitelist
                  bsStyle={bsStyle}
                  disabled={disabled}
                  onClick={onClick}>{loading} {img} {icon} {label}</Button>
        );

        if (tooltip && !__IS_MOBILE__ && !disabled) {
            tooltip = (<Tooltip id="tooltip">{tooltip}</Tooltip>);
            if (!tooltipPosition) {
                tooltipPosition = "top";
            }

            button = (
                <OverlayTrigger placement={tooltipPosition}
                                trigger={['hover', 'focus']}
                                overlay={tooltip}>
                    {button}
                </OverlayTrigger>
            );
        }

        return button;
    }
}

_Button.propTypes = {
    label: PropTypes.any,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    bsStyle: PropTypes.string,
    onClick: PropTypes.func,
    img: PropTypes.string,
    imgStyle: PropTypes.object,
    icon: PropTypes.string,
    iconStyle: PropTypes.object,
    tooltip: PropTypes.string,
    hideOnMobile: PropTypes.bool
};

export default _Button;